import { Dictionary } from '@skylab-shared/types';
import { Violation } from './../../validation';

export enum RepositoryResponseCode {
    Success = 1,
    ValidationError,
    Conflict,
    OutOfDateData,
    DataNotFound,
    ExternalError,
    TooManyRequests,
    Forbidden
}

export enum RepositoryResponseConflictCodes {
    UniqueConstraintViolation = 'UniqueConstraintViolation',
    EntityAlreadyCreated = 'EntityAlreadyCreated'
}

export enum RepositioryErrorCode {
    CannotDeleteAssociatedEntity = 'CannotDeleteAssociatedEntity',
    CannotDeleteDictionaryDefaultItem = 'CannotDeleteDictionaryDefaultItem',
    CannotDeleteSystemValueEntity = 'CannotDeleteSystemValueEntity'
}

export interface RepositorySaveResponse<TData = any> {
    readonly code: RepositoryResponseCode;
    readonly object?: {
        readonly id: number;
        readonly externalId?: string;
        readonly version: string
    } & Readonly<TData>;
}

export interface SaveForbiddenResponse<TForbiddenCodes> extends RepositorySaveResponse {
    readonly kind?: TForbiddenCodes;
}

export interface SaveConflictResponse<TConflictCodes> extends RepositorySaveResponse {
    readonly conflicts?: ResponseConflictObject<TConflictCodes>[];
}

export interface ResponseConflictObject<TConflictCodes, TData = unknown> extends Dictionary<unknown> {
    readonly objectProperties?: string[] | TData[];
    readonly code?: TConflictCodes;
}

export interface ExternalRuleViolation<TModel> {
    property: keyof TModel;
    violation: Violation;
}

export interface DeleteResponse {
    deletedSuccessfully: boolean;
    responseCode?: RepositoryResponseCode;
    errorCode?: RepositioryErrorCode | string;
    target?: string;
}
